import type { RetryDecision } from '@e-socna/better-fetch';

import { MAX_RETRY_DELAY_MS } from '../proxy/constants/delay.constant';

/**
 * Calculate minimum delay based on rate limit
 * For example, 5 req/s means minimum 200ms between requests
 */
export const calculateMinDelayForRate = (requestsPerSecond: number): number =>
  Math.ceil(1_000 / requestsPerSecond);

/**
 * Handle network errors and timeouts with exponential backoff
 */
export const handleNetworkError = (attempt: number): RetryDecision => {
  const delay = 500 * 2 ** attempt;
  return {
    shouldRetry: true,
    delayMs: Math.min(delay, MAX_RETRY_DELAY_MS),
  };
};

/**
 * Handle server errors (5xx) with exponential backoff
 */
export const handleServerError = (attempt: number): RetryDecision => {
  const delay = 1_000 * 2 ** attempt;
  return {
    shouldRetry: true,
    delayMs: Math.min(delay, MAX_RETRY_DELAY_MS),
  };
};
